import { render, staticRenderFns } from "./OrderFoodCounter.vue?vue&type=template&id=c338a96c&scoped=true"
import script from "./OrderFoodCounter.vue?vue&type=script&lang=js"
export * from "./OrderFoodCounter.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodCounter.vue?vue&type=style&index=0&id=c338a96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c338a96c",
  null
  
)

export default component.exports